import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuperadminRoutingModule } from './superadmin-routing.module';
import { ModulosModule } from './modulos/modulos.module';
import { CierreModule } from './cierre/cierre.module';
import { ConfigModule } from './config/config.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SuperadminRoutingModule,
    ModulosModule,
    CierreModule,
    ConfigModule,
  ],
})
export class SuperadminModule { }
